import axios from 'axios';

// JWT token management for the admin panel.
export const getToken = () => localStorage.getItem('admin_token');
export const setToken = (token) => localStorage.setItem('admin_token', token);
export const removeToken = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_auth');
  localStorage.removeItem('admin_username');
};

// Installs the global axios interceptors that (a) attach the admin Bearer token
// to every /api/ request and (b) handle 401 redirects + GET retries.
//
// IMPORTANT: this is imported and called eagerly from index.js so the interceptor
// is ALWAYS installed at app startup — not only when the Dashboard chunk loads.
// (Previously it lived inside the AdminDashboard chunk, so deep-linking/refreshing
// directly onto /admin/settings sent settings/upload saves with no token → 401.)
export const installAdminAxiosInterceptors = () => {
  if (globalThis.__bcmAdminAxiosInterceptorsInstalled) {
    return;
  }

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token && config.url?.includes('/api/')) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config || {};
      const method = (config.method || 'get').toLowerCase();
      const shouldRetry = method === 'get' && (!error.response || error.response.status >= 500);
      const retryCount = config.__retryCount || 0;

      if (shouldRetry && retryCount < 2) {
        config.__retryCount = retryCount + 1;
        await new Promise((resolve) => setTimeout(resolve, 350 * config.__retryCount));
        return axios(config);
      }

      if (error.response?.status === 401) {
        removeToken();
        if (window.location.pathname.startsWith('/admin') && !window.location.pathname.includes('/login')) {
          window.location.href = '/admin/login';
        }
      }

      return Promise.reject(error);
    }
  );

  globalThis.__bcmAdminAxiosInterceptorsInstalled = true;
};
